export default "__VITE_PUBLIC_ASSET__23873de6__"